import { tv } from 'tailwind-variants'

import { caption, h5 } from '@ui-kit/core/typography'

export const alert = tv({
  slots: {
    container:
      'flex w-full cursor-pointer flex-row items-center gap-x-2.5 rounded-lg p-4 hover:opacity-70 active:opacity-70 web:transition-opacity web:duration-300 web:ease-in-out',
    textContainer: 'flex-1',
    title: h5(),
    message: caption(),
  },
  variants: {
    variant: {
      error: {
        container: 'bg-error-light',
        title: 'text-error',
        message: 'text-error',
      },
      warning: {
        container: 'bg-warning-light',
        title: 'text-warning',
        message: 'text-warning',
      },
      success: {
        container: 'bg-success-light',
        title: 'text-success',
        message: 'text-success',
      },
    },
  },
})
